import React, { useEffect } from "react";
import { Button, Text } from "components";
import { useTranslation } from "react-i18next";
import { PickUpPointsListItem } from "components/PickUpPointsListItem";
import { PickUpPoint } from "popups/PickUpPoint";
import { useDispatch, useSelector } from "react-redux";
import {
  updateOrderData,
  getOrderData,
} from "../../../../../redux/reducers/orderData";
import { changeTrigger } from "redux/reducers/trigger";

const PickUpPointsList = (props) => {
  const { zoneList, isEventSent, setIsEventSent, sendCheckoutGaEvent } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const orderData = useSelector(getOrderData);
  const [pickUpPoints, setPickUpPoints] = React.useState(false);

  // FIX #3: isRestoringRef — cart version (doc 7) ki tarah. Jab hum programmatically
  // selectedZone set karte hain (restoration ke waqt), toh useEffect ko deliverHear()
  // call karne se rokne ke liye yeh ref use hoti hai.
  const isRestoringRef = React.useRef(false);

  const [selectedZone, setSelectedZone] = React.useState({
    pickUpPoint: {},
    zoneIndex: -1,
    selected: false,
  });

  /*
   * set address data
   */
  const deliverHear = () => {
    if (!isEventSent?.addShippingInfo) {
      setIsEventSent((prev) => ({ ...prev, addShippingInfo: true }));
      sendCheckoutGaEvent("add_shipping_info");
    }
    const updatedOrderData = {
      ...orderData,
      delivery_mode_show: "hide",
      home_office: selectedZone?.pickUpPoint,
      pageStep: 3,
      delivery_mode: "pickup_point",
    };
    if (orderData?.delivery_type === "fastest") {
      updatedOrderData.timeSloat = {};
      updatedOrderData.delivery_type = "";
    }
    dispatch(updateOrderData(updatedOrderData));
    dispatch(changeTrigger("closepopup"));
  };

  const handelsetpickUpPoints = () => {
    setPickUpPoints(true);
    document.body.classList.add("overflow-hidden");
    document.getElementById("header-box").classList.add("relative");
  };

  useEffect(() => {
    if (selectedZone?.selected) {
      // FIX #3: Agar restoration chal rahi hai toh deliverHear() call mat karo
      if (isRestoringRef.current) {
        isRestoringRef.current = false;
        return;
      }
      if (pickUpPoints) {
        setPickUpPoints(false);
        document.body.classList.remove("overflow-hidden");
        document.getElementById("header-box").classList.remove("relative");
      } else {
        deliverHear();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedZone, pickUpPoints]);

  // FIX #3: Jab user wapas step 2 par aaye aur pickup_point delivery mode select tha,
  // toh pehle select kiya hua pickup point zoneList mein dhundh kar restore karo.
  // Cart version (doc 7) mein yeh localStorage se hota tha; yahan hum orderData se
  // directly match karte hain (orderData?.home_office mein pickup point ka data hota hai).
  useEffect(() => {
    if (orderData?.pageStep !== 2) return;

    // Sirf tab restore karo jab delivery_mode pickup_point tha
    if (
      orderData?.delivery_mode === "pickup_point" &&
      orderData?.home_office &&
      zoneList?.length > 0
    ) {
      const savedPickup = orderData?.home_office;
      // ID se match karo
      const matchIndex = savedPickup?.id
        ? zoneList.findIndex((z) => z.id === savedPickup?.id)
        : -1;

      if (matchIndex !== -1) {
        // FIX #3: isRestoring true karo taaki useEffect deliverHear() na chalaaye
        isRestoringRef.current = true;
        setSelectedZone({
          pickUpPoint: zoneList[matchIndex],
          zoneIndex: matchIndex,
          selected: true,
        });
      } else if (savedPickup?.localName) {
        // Naam se match karo agar ID nahi mili
        const matchByName = zoneList.findIndex(
          (z) => z.localName === savedPickup?.localName
        );
        if (matchByName !== -1) {
          isRestoringRef.current = true;
          setSelectedZone({
            pickUpPoint: zoneList[matchByName],
            zoneIndex: matchByName,
            selected: true,
          });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zoneList, orderData?.pageStep, orderData?.delivery_mode]);

  return (
    <>
      <div className="mt-2.5 w-full">
        {/* Section title — Cart style: Inter font, 20px */}
        {/* <Text className="text-base text-black-900 font-nunitomedium mb-6">
          {t("pickUpPointsNearYou")}
        </Text> */}

        <div className="flex flex-col gap-4">
          {zoneList?.length > 0 ? (
            <>
              <PickUpPointsListItem
                zoneList={zoneList}
                setSelectedZone={setSelectedZone}
                selectedZone={selectedZone}
              />
              <div className="w-full h-px bg-gray-300"></div>

              {/* View All — Cart style: Inter font */}
              <div
                className="flex flex-1 flex-row items-center justify-between w-full"
                onClick={handelsetpickUpPoints}
              >
                <Button className="flex flex-1 flex-row items-center justify-start w-full gap-2">
                  <Text className="common-pointer text-center text-pink-800 text-sm w-auto font-['Inter']">
                    {t("viewAll")}
                  </Text>
                </Button>
                {/* {zoneList?.length ? (
                  <Button
                    className="w-auto mx-auto px-3 py-1.5 text-sm xs:mx-0"
                    size="sm"
                    variant={!selectedZone?.selected ? "FillBlack" : "OutlineBlack"}
                    hover={!selectedZone?.selected ? false : true}
                    hoverclass="bg-black-900"
                    disabled={!selectedZone?.selected}
                    onClick={deliverHear}
                  >
                    {t("continue")}
                  </Button>
                ) : null} */}
              </div>
            </>
          ) : (
            <div>{t("data_not_found")}</div>
          )}
        </div>
      </div>
      {pickUpPoints === true ? (
        <PickUpPoint
          closepopup={() => {
            setPickUpPoints(false);
            document.body.classList.remove("overflow-hidden");
            document.getElementById("header-box").classList.remove("relative");
          }}
          zoneList={zoneList}
          selectedZone={selectedZone}
          setSelectedZone={setSelectedZone}
          deliverHear={deliverHear}
        />
      ) : null}
    </>
  );
};

export default PickUpPointsList;
